
const functionName = {

  AdminSendTransferMessage: "adminSendTransferMessage",

  UpsertPaymentIntent:"upsertPaymentIntent",

  StartAdminTransactionDirect:"startAdminTransactionDirect",

  UpsertSubMerchant:"upsertSubMerchant",

  CalculateServiceFee:"calculateServiceFee",

  GenerateTransactionReport:"generateTransactionReport",

  CreateConnectedAccount:"createConnectedAccount",
  
  CreateConnectedAccountSession:"createConnectedAccountSession",

  CopyConnectedAccount:"copyConnectedAccount",

  CompleteTransactionDirect:"completeTransactionDirect",

  AdminCompleteTransactionDirect:"adminCompleteTransactionDirect",
 
  AssignRegistration:"assignRegistration",

  CancelRegistrationAssignment:"cancelRegistration",

  CancelTransfer:"cancelTransfer",

  TransferRegistration:"transferRegistration",

  RedeemRegistration:"redeemRegistration",

  EventManagerInviteRespond:"eventManagerInviteRespond",

  AdminUpdateRegistrationTransfer:"adminUpdateRegistrationTransfer",
  
  IsRegistered: "isRegistered",

  ContentGenerateStopQRPrint: "contentGenerateStopQRPrint",
};

export default functionName;